import { BottomSheet, type UseModalState } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";
import { Button } from "@src/appV2/redesign/components/Button";

interface InternalTimeClockNotWorkingReasonBottomSheetProps {
  modalState: UseModalState;
  onReasonPicked: (reason: "timeclock-not-working" | "pin-code-not-working") => void;
  onCancel: () => void;
}

export function InternalTimeClockNotWorkingReasonBottomSheet(
  props: InternalTimeClockNotWorkingReasonBottomSheetProps
) {
  const { modalState, onReasonPicked, onCancel } = props;

  return (
    <BottomSheet modalState={modalState}>
      <Stack sx={{ padding: 5, gap: 5 }}>
        <Button
          size="large"
          variant="outlined"
          onClick={() => {
            onReasonPicked("pin-code-not-working");
          }}
        >
          PIN code not working
        </Button>
        <Button
          size="large"
          variant="outlined"
          onClick={() => {
            onReasonPicked("timeclock-not-working");
          }}
        >
          Time clock not working
        </Button>
        <Button size="large" variant="outlined" onClick={onCancel}>
          Go back
        </Button>
      </Stack>
    </BottomSheet>
  );
}
